export default "/_next/static/data/illo-hero-leading-customer-ai-powered_F2.json-ca6469cd9436b25c340e8e2d22a15a1a.json";